// removed by extract-text-webpack-plugin
module.exports = {"withIcon":"withIcon___2f8hN","btnIcon":"btnIcon___1z-gD","addFileIcon":"addFileIcon___3VhHu","exportFile":"exportFile___1i-ZA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ExportFile/styles.less
// module id = 8O1H
// module chunks = 18